import script from "./TextQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./TextQuestion.vue?vue&type=style&index=0&id=d0de9666&lang=scss"

const __exports__ = script;

export default __exports__